import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/logo.png';
import './Navbar.css';

const Navbar = () => {
  const [darkNav, setDarkNav] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  // Change navbar style on scroll
  const handleScroll = () => {
    if (window.scrollY > 50) {
      setDarkNav(true);
    } else {
      setDarkNav(false);
    }
  };

  // Close mobile menu on outside click
  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setMenuOpen(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleMenu = () => {
    setMenuOpen(prev => !prev);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <nav className={`navbar ${darkNav ? 'dark-nav' : ''}`}>
      <div className="navbar-container">
        {/* Logo */}
        <Link to="/" className="logo" onClick={closeMenu}>
          <img src={logo} alt="Logo" className="logo-img" />
          <span className="logo-text">
            <span className="bal-jyoti">Bal Jyoti</span> <span className="foundation">Foundation</span>
          </span>
        </Link>

        {/* Hamburger Icon */}
        <div className="menu-toggle" onClick={toggleMenu}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>

        {/* Nav Links */}
        <ul ref={menuRef} className={`nav-links ${menuOpen ? 'active' : ''}`}>
          <li><Link to="/" onClick={closeMenu}>Home</Link></li>
          <li><Link to="/about" onClick={closeMenu}>About Us</Link></li>
          <li><Link to="/joinus" onClick={closeMenu}>Join Us</Link></li>
          <li><Link to="/events" onClick={closeMenu}>Events</Link></li>
          <li><Link to="/contacts" onClick={closeMenu}>Contacts</Link></li>
        </ul>

        {/* Donate button visible on desktop */}
        <Link to="/donation" className="donate-desktop" onClick={closeMenu}>
          <button className="donation-button">Donate</button>
        </Link>
      </div>
    </nav>
  );
};

export default Navbar;
